import useSWR from 'swr'
import { fetchSyncRun, startSync, type SyncRun } from '@/lib/api/sources.ts'

export function isRunActive(run: SyncRun | null | undefined): boolean {
  return run?.state === 'queued' || run?.state === 'running'
}

export function useSyncRun(pipelineId: string, enabled = true) {
  const { data, mutate } = useSWR(
    enabled ? `/pipelines/${pipelineId}/sync` : null,
    () => fetchSyncRun(pipelineId),
    { refreshInterval: (latest) => (isRunActive(latest) ? 2000 : 0) },
  )

  return {
    run: data ?? null,
    active: isRunActive(data),
    refresh: mutate,
    async start() {
      await startSync(pipelineId)
      await mutate()
    },
  }
}
